import * as React from "react";
const SvgSlashCircle01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#slash-circle-01_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.965 12A8.965 8.965 0 0 0 6.437 4.973l12.59 12.59A8.92 8.92 0 0 0 20.964 12m-17.93 0A8.965 8.965 0 0 0 12 20.965a8.92 8.92 0 0 0 5.563-1.939L4.973 6.436A8.92 8.92 0 0 0 3.035 12m20 0c0 6.095-4.94 11.035-11.035 11.035S.965 18.095.965 12 5.905.965 12 .965 23.035 5.905 23.035 12"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "slash-circle-01_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgSlashCircle01;
//# sourceMappingURL=SlashCircle01.js.map